import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-modal-content" }
const _hoisted_2 = { class: "edit-modal-content__header header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "header__description" }
const _hoisted_5 = { class: "edit-modal-content__main-content main-content" }
const _hoisted_6 = { class: "main-content__container" }
const _hoisted_7 = { class: "main-content__change-basic-info" }
const _hoisted_8 = { class: "main-content__select-input-content select-input-content" }
const _hoisted_9 = {
  key: 0,
  class: "main-content__forecast-name-content forecast-name-content"
}
const _hoisted_10 = { class: "forecast-name-content__label" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "edit-modal-content__footer footer" }

import { i18n } from '@/i18n';
import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { computed, reactive, watch } from 'vue';
import MultipleUserSelectInput from '@/corePagesModule/user/SelectInput/MultipleUserSelectInput.vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'EditForecastModal',
  props: {
    modalState: { type: Boolean, default: false },
    selectInputIndex: { default: 0 },
    showForecastName: { type: Boolean, default: false }
  },
  emits: ["closeModal", "apply"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;

const state = reactive<{
  selectedStaffIdList: string[];
  forecastForReceiptName: string;
}>({
  selectedStaffIdList: [],
  forecastForReceiptName: '',
});

/**
 * 適用ボタンをクリックした時の処理
 */
const onClickApply = () => {
  emits('apply', state.selectedStaffIdList, props.showForecastName ? state.forecastForReceiptName : undefined);
};

watch(
  () => props.modalState,
  () => {
    if (!props.modalState) {
      state.selectedStaffIdList = [];
      state.forecastForReceiptName = '';
    }
  }
);

const isDisabledApplyEditButton = computed(() => {
  if (props.showForecastName) {
    return !state.selectedStaffIdList.length || !state.forecastForReceiptName.trim();
  }
  return !state.selectedStaffIdList.length;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "edit-modal-container",
    "modal-size": 764,
    "stretch-container": true,
    "scroll-off": true,
    padding: '16px',
    "modal-state": _ctx.modalState,
    "border-radius": '16px',
    onOutsideClick: _cache[2] || (_cache[2] = ($event: any) => (emits('closeModal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('編集')), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('forecastForReceipt_descriptionOfEditForecast')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(MultipleUserSelectInput, {
                  "select-input-index": _ctx.selectInputIndex,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (state.selectedStaffIdList = $event))
                }, null, 8, ["select-input-index"])
              ]),
              (_ctx.showForecastName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)('受領用内示')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.forecastForReceiptName) = $event)),
                      class: "forecast-name-content__input",
                      type: "text",
                      placeholder: _unref(t)('受領用内示名')
                    }, null, 8, _hoisted_11), [
                      [_vModelText, state.forecastForReceiptName]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(TextButton, {
            "button-style": 'btn-cancel',
            size: 'btn-md',
            "on-click": () => emits('closeModal'),
            class: "footer__button footer__button--cancel"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["on-click"]),
          _createVNode(TextButton, {
            class: "footer__button footer__button--confirm",
            "button-style": 'btn-primary',
            size: 'btn-md',
            disabled: isDisabledApplyEditButton.value,
            "on-click": onClickApply
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('適用')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state"]))
}
}

})